import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useEJLogContext } from '../../../EJLogContext'
import { EngineeringJudgement } from '../../../EJLogContext/types'

export function useCreate():
  | CreateHeaderActionOptions<EngineeringJudgement>
  | undefined {
  const {
    payItemGlobalId,
    fetching,
    draftSubmitModal: { toggle },
  } = useEJLogContext()
  if (payItemGlobalId) return undefined
  return {
    loading: fetching,
    entity: 'Engineering Judgement',
    permission: Permission.CreateEngineeringJudgement,
    modal: { type: 'custom', toggle },
  }
}
